import React, { useContext, useEffect, useState } from 'react';
import { Badge, Container, Image } from "react-bootstrap"
import { Link } from "react-router-dom"
import FavoriteIcon from "../FavoriteIcon"
import * as Icon from 'react-bootstrap-icons';
import ApiFetch from "../ApiFetch";
import FollowButton from '../FollowButton';
import { useTranslation } from "react-i18next";
import UserMark from '../UserMark';

const UserInfoPopup = (props) => {
    const {t,i18n} = useTranslation()
    let data = props.data
    let displayId = props.displayId || ""
    let selfIntroduction = String(props.selfIntroduction)
    let follow = props.follow
    let follower = props.follower
    let isFollow = props.isFollow
    let random = props.random
    return (
        <Container 
        onMouseLeave={(e) => {
            document.getElementById("sub-"+random).style.display = "none"
        }}
        className='p-2' id={"sub-"+random} style={{width:"200px",top:"100px",position:"absolute",display:"none",zIndex:4,backgroundColor:"#FFFFFF",borderRadius:"15px",boxShadow:"3px 3px 8px #AAAAAA"}}>
            <Container>
                <Link to={"/user/"+(displayId !== "" ? data.display_id : data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}>
                    <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/'+(data.user_id)+'_s.jpg?'+data.hash} style={{marginRight:"10px",borderRadius:"25px",display:data.user_id ? "inline" : "none"}} width="50px" height="50px" />
                </Link>
                <FollowButton userId={data.user_id} follow={data.follow || isFollow} userName={data.user_name} />
            </Container>
            <Container style={{fontWeight:"bold"}}>
                <Link to={"/user/"+(displayId !== "" ? data.display_id : data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}>{data.user_name}</Link>
                <UserMark sms_auth={data.sms_auth} role={data.role} plan={data.plan} creator={data.certified_creator === 1} dialog={props.dialog} />
            </Container>
            <Container style={{color:"#555555"}}>{displayId !== "" && displayId.length > 0 ? "@" + displayId : ""}</Container>
            <Container className="p-1">{selfIntroduction.length > 100 ? selfIntroduction.substring(0,100) + "..." : selfIntroduction}</Container>
            <Container>
                <strong>{follow}</strong> {t("common.follow")} <strong>{follower}</strong> {t("common.follower")}
            </Container>
        </Container>
    )
}

export default UserInfoPopup